import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React from 'react';

import { selectedRoomPropTypes } from '../../../propTypes';
import { tourHotelRoomOptionPropTypes } from './PropTypes';

import InputIncrement from '../Atoms/InputIncrement';

const propTypes = exact({
  handleChange: PropTypes.func.isRequired,
  partySize: PropTypes.number.isRequired,
  roomTypes: PropTypes.arrayOf(tourHotelRoomOptionPropTypes).isRequired,
  selectedValues: PropTypes.arrayOf(selectedRoomPropTypes).isRequired,
});

function RoomSelection(props) {
  let totalRooms = 0;
  props.selectedValues.forEach((selectedValue) => {
    totalRooms += selectedValue.roomCount;
  });

  const getRoomCountForRoomKey = (roomKey) =>
    props.selectedValues?.find((s) => s.roomKey === roomKey)?.roomCount || 0;

  // to do upgrade room error hardcoded.
  return (
    <div className="UpgradeRooms">
      {props.roomTypes.map(({ key, roomName }) => (
        <div className="UpgradeRooms_room" key={key}>
          <div className="UpgradeRooms_field">
            <InputIncrement
              fieldID={key}
              handleChange={props.handleChange}
              maxValue={props.partySize}
              minValue={0}
              selectedValue={getRoomCountForRoomKey(key)}
            />
          </div>
          <div className="UpgradeRooms_label">{roomName}</div>
        </div>
      ))}
      {totalRooms > props.partySize && (
        <div className="UpgradeRooms_error">
          You have selected {props.partySize} party members and {totalRooms} rooms.
        </div>
      )}
    </div>
  );
}

RoomSelection.propTypes = propTypes;

export default RoomSelection;
